const resetPassword = {
  reset_password: "Reset Password",
  password: "Password",
  welcometext_reset: "The password shoud have atleast 6 characters",
  confirmpassword: "Confirm Password",
  error_email_required: "Email is required",
  error_valid_email: "Please enter valid email address",
  error_password_required: "Password is required",
  error_confirm_password_required: "Confirm Password is required",
  error_password_upper: "At least 1 uppercase character",
  error_password_lower: "At least 1 lowercase character",
  error_password_number: "At least 1 digit",
  error_password_special: "At least 1 special character",
  error_password_min: "Minimum 6 characters",
  error_password_max: "Maximum 16 characters",

  error_valid_password:
    "At least 1 uppercase character,At least 1 lowercase character, At least 1 digit, At least 1 special character,Minimum 6 characters and Maximum 16 characters.",
  error_password_not_match: "The passwords do not match",
  backtologin: "Back to login",
  success_message: "Password Reset Successfully",
  error_something_went_wrong: "Something Went Wrong...",
};
export default resetPassword;
